export enum Auditor {
  GPIA = 'GPIA',
  GPRM = 'GPRM',
  ADMIN = 'admin'
}
